export default __webpack_public_path__ + "static/media/timer.abcca681.svg";